import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { LinkList } from '../../../../components';

import './style.scss';

interface ViewFaqMenuItem {
  id: number;
  link: string;
  title: string;
  isActive?: boolean;
}

export interface ViewFaqMenuProps {
  items: ViewFaqMenuItem[];
}

const ViewFaqMenu: React.FC<ViewFaqMenuProps> = (props) => {
  const { items } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'views.faq.menu' });

  return (
    <nav className="ViewFaqMenu">
      <h2 className="ViewFaqMenu__title asH4">
        {t('title')}
      </h2>

      <LinkList className="ViewFaqMenu__list">
        {items.map(({
          id, link, title, isActive,
        }) => {
          const itemClasses = c('ViewFaqMenu__list-item', {
            'ViewFaqMenu__list-item--active': isActive,
          });

          return (
            <LinkList.TertiaryItem
              key={`faq-menu-item:${id}`}
              className={itemClasses}
              link={link}
              title={title}
            />
          );
        })}
      </LinkList>
    </nav>
  );
};

export default ViewFaqMenu;
